const classes = [
    "layui-layer",
    ".layui-layer-title",
    ".layui-layer-main",
    ".layui-layer-dialog",
    "layui-layer-iframe",
    "layui-layer-content",
    "layui-layer-btn",
    "layui-layer-close"
];
classes.anim = [
    "layer-anim-00",
    "layer-anim-01",
    "layer-anim-02",
    "layer-anim-03",
    "layer-anim-04",
    "layer-anim-05",
    "layer-anim-06"
];

export default classes;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/goingDialog/classes.js